import { create } from 'zustand';

type SidebarStore = {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
  isMobileOpen: boolean;
  openMobile: () => void;
  closeMobile: () => void;
  toggleMobile: () => void;
};

const useSidebarStore = create<SidebarStore>(set => ({
  isCollapsed: false,
  toggleCollapsed: () => set(state => ({ isCollapsed: !state.isCollapsed })),
  isMobileOpen: false,
  openMobile: () => set({ isMobileOpen: true }),
  closeMobile: () => set({ isMobileOpen: false }),
  toggleMobile: () => set(state => ({ isMobileOpen: !state.isMobileOpen })),
}));

export { useSidebarStore };
